export const spellLink = (previewUrl, launch) => {
  const link = 'http://res1.adyun.com/res1/Experience/' + launch.id + '/'
  const xpath = encodeBase64(link + launch.id + '%2c' + launch.title + '%2c' + launch.contact + '%2c' + launch.link)
  let newLink
  if (previewUrl.indexOf('?') > -1) {
    newLink = previewUrl + '&_x=' + xpath
  } else {
    newLink = previewUrl + '?_x=' + xpath
  }
  // console.log(newLink)
  window.open(newLink)
}

const utf16to8 = (str) => {
  let i, c
  let out = ''
  for (i = 0; i < str.length; i++) {
    c = str.charCodeAt(i)
    if ((c >= 0x0001) && (c <= 0x007F)) {
      out += str.charAt(i)
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
    } else {
      out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
    }
  }
  return out
}

const encodeBase64 = (st) => {
  const str = utf16to8(st)
  const map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-' // Base64从0到63的对应编码字符集
  let buffer
  let result = ''
  let flag = 0
  const arr = []

  for (let i = 0; i < str.length; i++) {
    arr.push(str.charCodeAt(i) & 0xFF)
  }

  flag = arr.length % 3
  if (flag === 1) {
    arr.push(0, 0)
  } else if (flag === 2) { arr.push(0) }

  for (let j = 0; j < arr.length; j += 3) {
    buffer = (arr[j] << 16) + (arr[j + 1] << 8) + arr[j + 2]
    result += map.charAt(buffer >> 18) + map.charAt(buffer >> 12 & 0x3F) + map.charAt(buffer >> 6 & 0x3F) + map.charAt(buffer & 0x3F)
  }
  if (flag === 1) {
    result = result.replace(/AA$/g, '==')
  } else if (flag === 2) {
    result = result.replace(/A$/g, '=')
  }
  return result
}



// WEBPACK FOOTER //
// ./src/components/medianav/launchPreview/launch.js